import {QUESTION_TYPES, YUJA_DROPDOWN_SIZE} from "../utils/constants";
import {questionCodeToSVG} from "../utils/questionUtils";
import classes from "./Dropdown.module.css";
import {YuJaDropdown} from "./standardization/YuJaDropdown";

export default function DropdownQuestionType({questionType, setShownQuestionType, handleQuestionTypeUpdate}) {

    const options = Object.values(QUESTION_TYPES).map(type => ({label: type.description, value: type.name}));


    const getOptionIcon = (option) => {
        return <span className={classes.icon} style={{width: 24, height: 24}}>{questionCodeToSVG(option.value, true, 16)}</span>;
    }

    const onChange = (option) => {
        handleQuestionTypeUpdate(option.label);
    }

    const onHover = (option) => {
        setShownQuestionType(option.value);
    }


    return (
        <div style={{position: 'relative', width: 190, height: 35}}>
            <YuJaDropdown
                size={YUJA_DROPDOWN_SIZE.SMALL}
                style={{width: 190, padding: "0 6px"}}
                data={options}
                value={questionType}
                onClose={() => setShownQuestionType(questionType)}
                onChange={onChange}
                onOptionHover={onHover}
                getOptionIcon={getOptionIcon}
                itemStyle={{gap: 7, padding: "0 10px"}}
            />
        </div>
    );
}